export function getErrorMessage(err: unknown): string {
  if (typeof err === 'string') {
    return err;
  }

  if (err instanceof Error) {
    return err.message;
  }

  if (assertErrorResponse(err)) {
    return err.body.message;
  }

  if (assertTSRestBodyError(err)) {
    return err.body.bodyErrors.issues
      .map((issue) => `${issue.path.join('.')}: ${issue.message}`)
      .join('\n');
  }
}

type ErrorResponse = {
  body: {
    message: string;
  };
};

function assertErrorResponse(err: unknown): err is ErrorResponse {
  return (
    assertRecord(err) &&
    assertObjectProperty(err, 'body') &&
    assertStringProperty(err.body, 'message')
  );
}

type TSRestBodyError = {
  body: {
    bodyErrors: {
      name: 'ValidationError';
      issues: Array<{
        expected: string;
        code: string;
        path: string[];
        message: string;
      }>;
    };
  };
};

export function assertTSRestBodyError(err: unknown): err is TSRestBodyError {
  return (
    assertRecord(err) &&
    assertObjectProperty(err, 'body') &&
    assertObjectProperty(err.body, 'bodyErrors') &&
    assertStringProperty(err.body.bodyErrors, 'name') &&
    err.body.bodyErrors.name === 'ValidationError'
  );
}

function assertStringProperty<
  T extends Record<string, unknown>,
  P extends string,
>(obj: T, path: P): obj is T & { [K in P]: string } {
  return typeof obj[path] === 'string';
}

function assertObjectProperty<
  T extends Record<string, unknown>,
  P extends string,
>(obj: T, path: P): obj is T & { [K in P]: Record<string, unknown> } {
  return assertRecord(obj[path]);
}

function assertRecord(err: unknown): err is Record<string, unknown> {
  return typeof err === 'object' && err !== null && !Array.isArray(err);
}
